"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestDriveRequestStatus = exports.LeadThrough = void 0;
var LeadThrough;
(function (LeadThrough) {
    LeadThrough["WEBSITE"] = "website";
})(LeadThrough = exports.LeadThrough || (exports.LeadThrough = {}));
var TestDriveRequestStatus;
(function (TestDriveRequestStatus) {
    TestDriveRequestStatus[TestDriveRequestStatus["NOT_CONTACTED"] = 1] = "NOT_CONTACTED";
    TestDriveRequestStatus[TestDriveRequestStatus["APPOINTMENT_CONFIRMED"] = 2] = "APPOINTMENT_CONFIRMED";
    TestDriveRequestStatus[TestDriveRequestStatus["FOLLOWED_UP_APPOINTMENT_DAY"] = 3] = "FOLLOWED_UP_APPOINTMENT_DAY";
    TestDriveRequestStatus[TestDriveRequestStatus["REQUESTED_CALL_BACK"] = 4] = "REQUESTED_CALL_BACK";
    TestDriveRequestStatus[TestDriveRequestStatus["FIRST_FOLLOW_UP"] = 5] = "FIRST_FOLLOW_UP";
    TestDriveRequestStatus[TestDriveRequestStatus["APPOINTMENT_NO_SHOW"] = 6] = "APPOINTMENT_NO_SHOW";
    TestDriveRequestStatus[TestDriveRequestStatus["SECOND_FOLLOW_UP"] = 7] = "SECOND_FOLLOW_UP";
    TestDriveRequestStatus[TestDriveRequestStatus["THIRD_FOLLOW_UP"] = 8] = "THIRD_FOLLOW_UP";
    TestDriveRequestStatus[TestDriveRequestStatus["FOURTH_FOLLOW_UP"] = 9] = "FOURTH_FOLLOW_UP";
    TestDriveRequestStatus[TestDriveRequestStatus["LAST_FOLLOW_UP"] = 10] = "LAST_FOLLOW_UP";
    TestDriveRequestStatus[TestDriveRequestStatus["ONGOING"] = 11] = "ONGOING";
    TestDriveRequestStatus[TestDriveRequestStatus["DEALING_VISITED"] = 12] = "DEALING_VISITED";
    TestDriveRequestStatus[TestDriveRequestStatus["CAR_BOOKED"] = 13] = "CAR_BOOKED";
    TestDriveRequestStatus[TestDriveRequestStatus["NO_DEAL_VISITED"] = 14] = "NO_DEAL_VISITED";
    TestDriveRequestStatus[TestDriveRequestStatus["PHONE_OFF"] = 15] = "PHONE_OFF";
    TestDriveRequestStatus[TestDriveRequestStatus["NO_ANSWER_TO_CALL"] = 16] = "NO_ANSWER_TO_CALL";
    TestDriveRequestStatus[TestDriveRequestStatus["CAR_NOT_IN_STOCK"] = 17] = "CAR_NOT_IN_STOCK";
    TestDriveRequestStatus[TestDriveRequestStatus["DISQUALIFIED"] = 18] = "DISQUALIFIED";
    TestDriveRequestStatus[TestDriveRequestStatus["WRONG_NUMBER"] = 19] = "WRONG_NUMBER";
})(TestDriveRequestStatus = exports.TestDriveRequestStatus || (exports.TestDriveRequestStatus = {}));
